import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Angular2CsvComponent } from "angular2-csv";

/**
 * Service files
 */
// import { DonationListService } from "../../../services/donation/donationList/donation-list.service"
import { ContactListService } from "../../../services/contacts/contactList/contact-list.service"
import { SearchContactCategoryService } from "../../../services/search/searchContactCategory/search-contact-category.service";
import { SearchEventService } from "../../../services/search/searchEvent/search-event.service";
import { GetStateService } from "../../../services/contacts/getState/get-state.service";
import { GetCountryService } from "../../../services/contacts/getCountry/get-country.service";
import { GetAllEducationService } from "../../../services/contacts/getAllEducation/get-all-education.service";
import { DownloadDonationService } from 'src/app/services/donation/downloadDonation/download-donation.service';


import Swal from 'sweetalert2'

import { DatepickerOptions } from 'ng2-datepicker';
import { Router } from '@angular/router';


declare var $: any
@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.less']
})
export class ContactListComponent implements OnInit {
  @ViewChild('countryID', null) countryID
  @HostListener("window:scroll", [])
  onWindowScroll() {
    var bodypos = document.documentElement.scrollHeight || document.body.scrollHeight;
    var windowh = document.documentElement.clientHeight || document.body.clientHeight;
    bodypos = bodypos - windowh;
    var windowpos = document.documentElement.scrollTop || document.body.scrollTop;;
    var persentage = Math.round((windowpos / bodypos) * 100);
    if (
      Math.round(persentage) > 95 &&
      this.NextCall == 1 &&
      this.filter == ""
    ) {
      this.StartRecord = +this.StartRecord + +this.lengthOfRecord
      this.dqloader = true;
      this.getAllDonationList(this.StartRecord, this.lengthOfRecord);
      this.NextCall = 0;
    }

  }
  @ViewChild(Angular2CsvComponent, null) csvComponent: Angular2CsvComponent;
  options: any = {}
  data: any = []

  public StartRecord: number = 0
  public lengthOfRecord: number = 10
  public NextCall: any;
  public dqloader: Boolean = false;
  public skeletonLoader: Boolean = true;
  public allContactData: any = []
  public filterKey: any = []
  public details: any = []
  public CategoryList: any = []
  public eventList: any = []
  public allState: any = []
  public allCountry: any = []
  public allEducation: any = []
  public verifyDonation: any

  public order: any = {
    order_column: "",
    order_direct: "desc"
  }

  public query: any = {
    partner_id: "",
    full_name: "",
  }

  public filter: any = ''

  public toSearch: Boolean = false


  public languageSkeleton = true
  public contactEventSkeleton = true
  public selectEventSkeleton = true
  public stateSkeleton = true
  public countrySkeleton = true
  public educationSkeleton = true
  public submitLoading: Boolean = false
  public exportButtonLoading: Boolean = false
  public fileName: any


  public search: any = {
    search: "",
    search_column: ""
  }


  /**
  * For Date picker options
  */
  datePickerOptions: DatepickerOptions = {
    minYear: 1970,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday 
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  public remoteContactList: boolean = false
  constructor(
    private ContactListService: ContactListService,
    private SearchContactCategoryService: SearchContactCategoryService,
    private SearchEventService: SearchEventService,
    private GetStateService: GetStateService,
    private GetCountryService: GetCountryService,
    private GetAllEducationService: GetAllEducationService,
    private router: Router,
    private DownloadDonationService: DownloadDonationService,
  ) {
    if (this.router.url == "/remoteContactList") {
      this.remoteContactList = true
    } else {
      this.remoteContactList = false
    }

  }

  async ngOnInit() {
    await this.getAllDonationList(0, this.lengthOfRecord)
    this.skeletonLoader = false
    setTimeout(function () {
      $(`.searchColumn`).selectpicker('refresh');
    }, 100)
  }

  async getAllDonationList(start, length) {
    this.dqloader = true;
    let response: any = await this.ContactListService.getAllList(
      this.search,
      start,
      length,
      this.order,
      this.query,
      this.filter,
      this.remoteContactList
    );
    console.log(response.data)
    if (response.data.length != 0) {
      response.data.forEach(element => {
        this.allContactData.push(element);
      });
      this.exportToCSVOptions()
      this.NextCall = 1;
      this.dqloader = false;
    } else {
      this.NextCall = 0;
      this.dqloader = false;
    }
  }

  async getTotalLength(value) {
    this.lengthOfRecord = value
    //  this.getAllReceipts(this.StartRecord,this.lengthOfRecord)
  }


  async getSearchColumn(ele) {

    if (ele != "") {
      this.toSearch = true
      this.search.search_column = ele
    } else {
      this.toSearch = false
    }
  }

  async searchBy() {
    this.search.search = $("#search").val()
    this.allContactData = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    this.NextCall = 0
  }

  async cancelSearch() {
    this.toSearch = false
    this.search.search_column = ""
    this.search.search = ""
    setTimeout(function () {
      $(`.searchColumn`).selectpicker('refresh');
    }, 100)
    this.allContactData = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
  }



  async outToParent(e) {
    if (e == 'success') {
      // this.isPrint = false 
      this.allContactData = []
      this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    }
  }

  async viewDetails(data) {
    $("#contactDetails").modal("show");
    this.details = data
  }

  async filterWithDetails(ele) {
    this.submitLoading = true
    console.log(ele)
    this.query = {
      partner_id: ele.partnerId == true ? $('#partnerIdTag').val() : '',
      full_name: ele.fullName == true ? $('#fullNameTag').val() : '',
      phone_number: ele.phoneNumber == true ? $('#phoneNumberTag').val() : '',
      address_line1: ele.address_line1 == true ? $('#addressLine1Tag').val() : '',
      address_line2: ele.address_line2 == true ? $('#addressLine2Tag').val() : '',
      address_line3: ele.address_line3 == true ? $('#addressLine3Tag').val() : '',
      city: ele.city == true ? $('#cityTag').val() : '',
      district: ele.district == true ? $('#districtTag').val() : '',
      state: ele.state == true ? ele.stateID.toString() : '',
      country: ele.country == true ? ele.countryID.toString() : '',
      pincode: ele.pinCode == true ? $('#pinCodeTag').val() : '',
      occupation: ele.occupation == true ? $('#occupationTag').val() : '',
      education: ele.education == true ? ele.educationID.toString() : '',
      language_id: ele.languageCheck == true ? ele.language != '' ? ele.language.toString() : 0 : 0,
      role_id: ele.contactCategoryCheck == true ? ele.contact != '' ? ele.contact.toString() : 0 : 0,
      event_id: ele.eventCheck == true ? ele.event != '' ? ele.event.toString() : 0 : 0,
      born_again_experience: ele.experience == true ? parseInt(ele.experiences) : '',
      holy_spirit_baptism: ele.holySpiritBaptism == true ? parseInt(ele.holySpiritBaptisms) : '',
      church_name: ele.churchName == true ? $('#churchNameTag').val() : '',
      from_date: ele.dateCheck == true ? $('#FromDate').val() : "",
      end_date: ele.dateCheck == true ? $('#ToDate').val() : ""
    }
    console.log(this.query)
    // this.filter = `partner_id=${this.query.partner_id}&full_name=${this.query.full_name}&phone_number=${this.query.phone_number}&address_line1=${this.query.address_line1}&address_line2=${this.query.address_line2}&address_line3=${this.query.address_line3}&city=${this.query.city}&district=${this.query.district}&state_id=${this.query.state}&country_id=${this.query.country}&pincode=${this.query.pincode}&occupation=${this.query.occupation}&education_id=${this.query.education}&language_id=${this.query.language_id}&role_id=${this.query.role_id}&event_id=${this.query.event_id}&born_again_experience=${this.query.born_again_experience}&holy_spirit_baptism=${this.query.holy_spirit_baptism}&church_name=${this.query.church_name}`
    this.filter = {
      partner_id: this.query.partner_id,
      full_name: this.query.full_name,
      phone_number: this.query.phone_number,
      address_line1: this.query.address_line1,
      address_line2: this.query.address_line2,
      address_line3: this.query.address_line3,
      city: this.query.city,
      district: this.query.district,
      state_id: this.query.state,
      country_id: this.query.country,
      pincode: this.query.pincode,
      occupation: this.query.occupation,
      education_id: this.query.education,
      language_id: this.query.language_id,
      role_id: this.query.role_id,
      event_id: this.query.event_id,
      born_again_experience: this.query.born_again_experience,
      holy_spirit_baptism: this.query.holy_spirit_baptism,
      church_name: this.query.church_name,
      from_date: this.query.from_date,
      end_date: this.query.end_date
    }

    this.allContactData = []
    this.StartRecord = null
    this.lengthOfRecord = null
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    this.submitLoading = false
  }


  async exportToCSVOptions() {
    let today = new Date();
    this.fileName = "BPM_Contact_List" + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();;
    this.options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: ["Partner Id", "Title Name", "Full Name", "Email Id", "Primary Mobile Number", "Alter Mobile Number", "Land Line Number", "Ban Id", "Address Line 1", "Address Line 2", "Address Line 3", "City", "State", "Province", "District", "Country", "Pin Code", "Date Of Birth", "Education", "Martial Status", "Occupation", "Sex", "Wedding Date", "Magazine Subscription Details", "Events Attended Details", "Partner Roles", "Language known", "Created Time"],
      showTitle: false,
      title: 'BPM Contacts',
      useBom: false,
      removeNewLines: true,
      keys: ["partner_id", "title_name", "full_name", "email_id", "primary_mobile_no", "alter_mobile_number", "land_line_no", "pan_id", "address_line1", "address_line2", "address_line3", "city", "state_name", "province", "district", "country_name", "pincode", "dob", "education_name", "martial_status", "occupation", "sex", "wedding_date", "mag_sub", "events", "roles", "language_known", "created_time"]
    };
    this.data = this.allContactData
  }


  async exportToCSV() {
    this.exportButtonLoading = true
    setTimeout(() => {
      this.csvComponent.onDownload();
      this.exportButtonLoading = false
    }, 1000)
  }

  async openSideFilter() {
    document.getElementById("mySidebar").style.width = "300px";
    document.getElementById("main").style.marginRight = "250px";

  }


  public partnerIdTagView = false
  public fullNameTagView = false
  public phoneNumberTagView = false
  public addressLine1TagView = false
  public addressLine2TagView = false
  public addressLine3TagView = false
  public cityTagView = false
  public districtTagView = false
  public stateTagView = false
  public countryTagView = false
  public pinCodeTagView = false
  public occupationTagView = false
  public languageTagView = false
  public contactCategoryTagView = false
  public eventTagView = false
  public educationTagView = false
  public experienceTagView = false
  public holySpiritBaptismTagView = false
  public churchNameTagView = false
  public dateView = false

  async openTagInput(key, val) {

    switch (key) {
      case "partnerIdTag":
        this.partnerIdTagView = val
        if (val) {
          setTimeout(() => {
            $(`#${key}`).tagsinput()
          }, 100)
        }
        break;
      case "fullNameTag":
        this.fullNameTagView = val
        break;
      case "phoneNumberTag":
        this.phoneNumberTagView = val
        break;
      case "addressLine1Tag":
        this.addressLine1TagView = val
        break;
      case "addressLine2Tag":
        this.addressLine2TagView = val
        break;
      case "addressLine3Tag":
        this.addressLine3TagView = val
        break;
      case "cityTag":
        this.cityTagView = val
        break;
      case "districtTag":
        this.districtTagView = val
        break;
      case "pinCodeTag":
        this.pinCodeTagView = val
        if (val) {
          setTimeout(() => {
            $(`#${key}`).tagsinput()
          }, 100)
        }
        break;
      case "occupationTag":
        this.occupationTagView = val
        break;
      case "stateTag":
        this.stateTagView = val
        this.stateValue = []
        if (val) {
          this.stateSelectionBoxRefresh()
        } else {
          this.stateSkeleton = true
        }
        break;
      case "countryTag":
        this.countryTagView = val
        this.countryValue = []
        if (val) {
          this.countrySelectionBoxRefresh()
        } else {
          this.countrySkeleton = true
        }
        break;
      case "educationTag":
        this.educationTagView = val
        this.educationValue = []
        if (val) {
          this.educationSelectionBoxRefresh()
        } else {
          this.educationSkeleton = true
        }
        break;
      case "languageTag":
        this.languageTagView = val
        if (val) {
          setTimeout(() => {
            this.languageSkeleton = false
          }, 95)

          setTimeout(function () {
            $(`.language`).selectpicker('refresh');
          }, 100)
        } else {
          this.languageSkeleton = true
        }
        break;
      case "contactCategoryTag":
        this.contactCategoryTagView = val
        this.contactValue = []
        if (val) {
          this.contactSelectionBoxRefresh()
        } else {
          this.contactEventSkeleton = true
        }
        break;
      case "eventTag":
        this.eventTagView = val
        this.eventValue = []
        if (val) {
          this.eventSelectionBoxRefresh()
        } else {
          this.selectEventSkeleton = true
        }
        break;
      case "experienceTag":
        this.experienceTagView = val
        break;
      case "holySpiritBaptismTag":
        this.holySpiritBaptismTagView = val
        break;
      case "churchNameTag":
        this.churchNameTagView = val
        break;
      case "dateTag":
        this.dateView = val
        break;
      default:
        break;
    }
  }


  async contactSelectionBoxRefresh() {
    await this.getContactCategoryLists()
    let root = this
    setTimeout(function () {
      root.contactEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.contact`).selectpicker('refresh');
    }, 100)
  }

  async getContactCategoryLists() {
    let category = await this.SearchContactCategoryService.getContactCategoryList()
    this.CategoryList = category.data
  }


  async eventSelectionBoxRefresh() {
    await this.getEventLists()
    let root = this
    setTimeout(function () {
      root.selectEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.event`).selectpicker('refresh');
    }, 100)
  }

  async getEventLists() {
    let event = await this.SearchEventService.getEventList()
    this.eventList = event.data
  }

  async stateSelectionBoxRefresh() {
    await this.getState()
    let root = this
    setTimeout(function () {
      root.stateSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.stateID`).selectpicker('refresh');
    }, 100)
  }

  async getState() {
    let state = await this.GetStateService.getAllState()
    this.allState = state.data
  }

  async countrySelectionBoxRefresh() {
    await this.getCountry()
    let root = this
    setTimeout(function () {
      root.countrySkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.countryID`).selectpicker('refresh');
    }, 100)
  }

  async getCountry() {
    let country = await this.GetCountryService.getAllCountry()
    this.allCountry = country.data
  }

  async educationSelectionBoxRefresh() {
    await this.getEducation()
    let root = this
    setTimeout(function () {
      root.educationSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.educationID`).selectpicker('refresh');
    }, 100)
  }

  async getEducation() {
    let education = await this.GetAllEducationService.getAllEducation()
    this.allEducation = education.data
  }

  public countryValue: any = []
  async getCountryValue(key, value) {
    var array = key
    this.countryValue = []
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      let res = value.filter(function (val) {
        return val.COUNTRY_ID == element
      });
      this.countryValue.push(res[0].COUNTRY_NAME)
    }
  }

  public stateValue: any = []
  async getStateValue(key, value) {
    var array = key
    this.stateValue = []
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      let res = value.filter(function (val) {
        return val.STATE_ID == element
      });
      this.stateValue.push(res[0].STATE_NAME)
    }
  }

  public educationValue: any = []
  async getEducationValue(key, value) {
    var array = key
    this.educationValue = []
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      let res = value.filter(function (val) {
        return val.EDUCATION_ID == element
      });
      this.educationValue.push(res[0].EDUCATION_NAME)
    }
  }

  public contactValue: any = []
  async getContactValue(key, value) {
    var array = key
    this.contactValue = []
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      let res = value.filter(function (val) {
        return val.role_id == element
      });
      this.contactValue.push(res[0].role_name)
    }
  }

  public eventValue: any = []
  async getEventValue(key, value) {
    var array = key
    this.eventValue = []
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      let res = value.filter(function (val) {
        return val.events_id == element
      });
      this.eventValue.push(res[0].event_name)
    }
  }

  async clearSelected() {
    $('#CountryID option:contains("Albania")').prop('selected', false).trigger("change");
    this.countryID.refresh()
  }

  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      event.preventDefault();
    }
  }

  async cancelSideFilter() {

    var uncheck = document.getElementsByTagName('input');
    for (var i = 0; i < uncheck.length; i++) {
      if (uncheck[i].type == 'checkbox') {
        uncheck[i].checked = false;
      }
    }

    this.partnerIdTagView = false
    this.fullNameTagView = false
    this.phoneNumberTagView = false
    this.addressLine1TagView = false
    this.addressLine2TagView = false
    this.addressLine3TagView = false
    this.cityTagView = false
    this.districtTagView = false
    this.stateTagView = false
    this.countryTagView = false
    this.pinCodeTagView = false
    this.occupationTagView = false
    this.languageTagView = false
    this.contactCategoryTagView = false
    this.eventTagView = false
    this.educationTagView = false
    this.experienceTagView = false
    this.holySpiritBaptismTagView = false
    this.churchNameTagView = false

    this.filter = ''
    this.allContactData = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllDonationList(this.StartRecord, this.lengthOfRecord)
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
  }

  async closeSideFilter() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
  }

  async moveRight() {
    event.preventDefault();
    $(".table-responsive").animate(
      {
        scrollLeft: "+=10000px"
      },
      "slow"
    );
  }

  async moveLeft() {
    event.preventDefault();
    $(".table-responsive").animate(
      {
        scrollLeft: "-=10000px"
      },
      "slow"
    );
  }

  async DownloadDonation(offering_id, partner_id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want download...!",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, download it!'
    }).then(async (result) => {

      if (result.value) {
        let result = await this.DownloadDonationService.download(offering_id, partner_id)
        if (result.status == "success") {
          Swal.fire(
            'Downloaded!',
            'Downloaded successfully...!',
            'success'
          )
        } else {
          Swal.fire(
            'Download!',
            'Download Failed...!',
            'warning'
          )
        }
      }
    })
  }


}
